import { proxy } from 'valtio';
import { StepIndexerState } from 'hooks/useStepIndexer';

export const cepViewStepIndexer = proxy<StepIndexerState>({
  stepIndex: 0,
  previousStep: 0,
});
